import {createDivIn, createSpanIn} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIDRoomInviteFriendsController} from './UIDRoomInviteFriendsController'
import {UIRoomFriendListController} from '../../../../shared/scripts/ui_html/room/UIRoomFriendListController'

export class UIDRoomFriendListController extends UIRoomFriendListController {
    private inviteFriendsButton: UIDRoomInviteFriendsController

    protected override showFriendListUI() {
        super.showFriendListUI()

        if(this.inviteFriendsButton != undefined) return
        this.inviteFriendsButton = new UIDRoomInviteFriendsController(this.friendListContainer)
    }

    override animateInviteFriendsButton() {
        this.inviteFriendsButton.animateInviteFriendsButton()
    }

    setRoomId(roomId: string) {
        this.inviteFriendsButton.setRoomId(roomId)
    }

    protected createEmptyFriendMessage() {
        const emptyFriendParentContainer = createDivIn(this.friendListContainer, 'room_friend_container')
        const emptyFriendMessageContainer = createDivIn(emptyFriendParentContainer, 'room_friend_empty_message_container')
        createSpanIn(emptyFriendMessageContainer, 'room_friend_empty_message_text', {key: 'strings:roomPage.noFriendsOnline', options: {context: 'discord'}})
        this.emptyFriendMessage = emptyFriendParentContainer
    }
}
